module.exports = __webpack_public_path__ + "static/media/Portrait-10199.d2a4c02d.jpg";